/**
 * Tracks in-flight API requests to detect active data work.
 */
let activeRequestCount = 0

export function incrementApiActivity(): void {
  activeRequestCount++
}

export function decrementApiActivity(): void {
  if (activeRequestCount > 0) activeRequestCount--
}

export function isWorkingWithData(): boolean {
  return activeRequestCount > 0
}

export function getActiveRequestCount(): number {
  return activeRequestCount
}
